import { reactive } from 'vue';
export default {
    state(state, moduleName = null) {
        const reactiveState = reactive(state);
        // if (process.env.NODE_ENV != "production" && DEBUG_MODE) {
        //     new Vue({
        //         created() {
        //             Object.keys(reactiveState).forEach(key => {
        //                 this.$watch(() => reactiveState[key], (value) => {
        //                     if (moduleName) {
        //                         console.log(`🔸 ${moduleName} state changed: ${key}`, value)
        //                     } else {
        //                         console.log(`🔹 Root state changed: ${key}`, value)
        //                     }
        //                 })
        //             })
        //         }
        //     })
        // }
        return reactiveState;
    }
};
